module.exports = __webpack_public_path__ + "static/img/mine1.ab380c98.png";